import type { ClienteNexo, SujetoFicha } from "../api.ts";
import { C } from "../theme.ts";
import { rutaAHash } from "../rutas.ts";
import { FichaHallazgos } from "../ficha/Ficha.tsx";

/**
 * La ficha de una persona o empresa del Registro Público de Comercio (etapa 4): lo que Argus afirma de ella (nexo.hallazgos con
 * `siger_actor` en su corrida), con las mismas piezas y el mismo orden que Argus Team. La abre el nombre de una fila del buscador del
 * Explorador. Antes se abría la ficha del sancionado con esta persona elegida en el dibujo viejo; esa página sigue a un clic, en las
 * relaciones de la fila. Desde el corte 4a de los certificados del SAT, también la de un representante sin ficha confirmada (sat_rep).
 */
export function FichaRegistro({ cliente, sujeto }: { cliente: ClienteNexo; sujeto: SujetoFicha }) {
  const explorador = rutaAHash({ vista: "explorador" });
  return (
    <div>
      <a href={explorador} style={{ fontSize: 13, color: C.tiel, textDecoration: "none", fontWeight: 600 }}>
        ← Explorador
      </a>
      <div style={{ marginTop: 10, background: "#fff", border: `1px solid ${C.line}`, borderRadius: 12, padding: "16px 18px" }}>
        <FichaHallazgos
          cliente={cliente}
          sujeto={sujeto}
          onBuscarDeNuevo={() => { window.location.hash = explorador; }}
        />
      </div>
    </div>
  );
}
